import { Clippy, addToGlobalThisRet } from "@plugins";

const textInnersFormFilesAttacher = new Clippy(".js-simple-form-files", {
    multi: true,
    accept: [".jpg", ".pdf", ".png", ".doc", ".docx"],
    input: {
        el: ".js-simple-form-files-input",
    },
    filesList: {
        classes: ["simple-form__files-list"],
        items: {
            template(file) {
                return `
                    <li class="simple-form__files-item">
                        <div class="simple-form__file-info">
                            <span class="simple-form__file-name">${file.name}.${file.extension}</span>
                        </div>
                        <button class="simple-form__files-item-remove" type="button" data-clippy-remover></button>
                    </li>
                `;
            },
        },
        insert: {
            functionType: "append",
        },
    },
    messages: {
        classes: ["simple-form__files-message"],
        types: {
            error: {
                classes: ["simple-form__files-message--error"],
            },
        },
        insert: {
            el: ".js-simple-form-files-label",
            functionType: "after",
        },
    },
});

addToGlobalThisRet(textInnersFormFilesAttacher, "textInnersFormFilesAttacher");

function resetAttachedFiles() {
    const filesList = document.querySelectorAll(".simple-form__files-item");

    if (filesList) {
        filesList.forEach((file) => file.querySelector("button").click());
    }
}

addToGlobalThisRet(resetAttachedFiles, "resetAttachedFiles");
